import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { RouterModule } from '@angular/router';
import { OverlayModule } from '@angular/cdk/overlay';

// Ng-Zorro Antd Modules
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NZ_I18N, en_US } from 'ng-zorro-antd/i18n';

// Third-Party Modules
import { JwtModule, JWT_OPTIONS } from '@auth0/angular-jwt';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

// Application Components
import { AppComponent } from './app.component';
import { HeaderComponent } from './common/header/header.component';
import { FooterComponent } from './common/footer/footer.component';
import { SideMenuComponent } from './common/side-menu/side-menu.component';

// Application Services
import { AuthGuardService } from './services/authGuard.service';
import { WatchStorageService } from './services/watchstorage.service';
import { AuthService } from './services/auth.service';
import { AdminsService } from './services/admins.service';
import { AnonymousService } from './services/anonymous.service';

// Routes
import { appRoutes } from './app.routes';

// Icons
import { IconsProviderModule } from './icons-provider.module';

// Global Services
import * as globals from './services/globlas';

registerLocaleData(en);

export function jwtOptionsFactory() {
  return {
    tokenGetter: () => localStorage.getItem('token'),
  };
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    SideMenuComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(appRoutes),
    OverlayModule,

    // Ng-Zorro Antd Modules
    NzButtonModule,
    NzLayoutModule,
    NzMenuModule,
    NzIconModule,
    NzGridModule,

    // Third-Party Modules
    JwtModule.forRoot({
      jwtOptionsProvider: {
        provide: JWT_OPTIONS,
        useFactory: jwtOptionsFactory,
      },
    }),
    NgxIntlTelInputModule,
    NgbModule,

    // Application Modules
    IconsProviderModule,
  ],
  providers: [
    { provide: NZ_I18N, useValue: en_US },
    AuthGuardService,
    WatchStorageService,
    globals.GetTokenNow,
    AuthService,
    AdminsService,
    AnonymousService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}